// Small shared helpers for deck list views.

import type { Deck } from '../api/types';
import type { SlideDeck } from './slide-model';

/** True when a deck is an empty V2 draft — created on the first chat message
 *  (so the chat persists) but with no slides generated yet. These are hidden
 *  from the Decks + Home lists so abandoned conversations don't clutter them;
 *  they remain openable via their /studio?deck=<id> URL. */
export function isEmptyDraft(d: Deck): boolean {
  const m = d.model as unknown as SlideDeck | null | undefined;
  return !!m && m.schemaVersion === 2 && (m.slides?.length ?? 0) === 0;
}
